/**
 * Module description...
 *
 * @returns {{init: init}}
 */
export default (() => {
  //console.log('Animations');

  const init = () => {
    // code to initialise the module
  };

  return {
    init
  };
})();
